/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmissionNotificationSettings } from './EmissionNotificationSettings';
import {
    EmissionNotificationSettingsFromJSON,
    EmissionNotificationSettingsFromJSONTyped,
    EmissionNotificationSettingsToJSON,
    EmissionNotificationSettingsToJSONTyped,
} from './EmissionNotificationSettings';

/**
 * 
 * @export
 * @interface PaginatedEmissionNotificationSettingsList
 */
export interface PaginatedEmissionNotificationSettingsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedEmissionNotificationSettingsList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionNotificationSettingsList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionNotificationSettingsList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<EmissionNotificationSettings>}
     * @memberof PaginatedEmissionNotificationSettingsList
     */
    results: Array<EmissionNotificationSettings>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedEmissionNotificationSettingsList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedEmissionNotificationSettingsList interface.
 */
export function instanceOfPaginatedEmissionNotificationSettingsList(value: object): value is PaginatedEmissionNotificationSettingsList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedEmissionNotificationSettingsListFromJSON(json: any): PaginatedEmissionNotificationSettingsList {
    return PaginatedEmissionNotificationSettingsListFromJSONTyped(json, false);
}

export function PaginatedEmissionNotificationSettingsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedEmissionNotificationSettingsList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(EmissionNotificationSettingsFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedEmissionNotificationSettingsListToJSON(json: any): PaginatedEmissionNotificationSettingsList {
    return PaginatedEmissionNotificationSettingsListToJSONTyped(json, false);
}

export function PaginatedEmissionNotificationSettingsListToJSONTyped(value?: PaginatedEmissionNotificationSettingsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(EmissionNotificationSettingsToJSON)),
        'num_pages': value['numPages'],
    };
}

